import { Component, Injector, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/common/base/base.component';
import { WFMasterResource, WFSectionConfig, WFTableConfig } from '../../workflow';
import { WorkFlowService } from 'src/app/components/workflow/workflow.service';
import { ChecklistElement, SelectedElement } from 'src/app/components/checklists/checklist-builder/checklist-builder-map/checklist-builder-map.component';
import { moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'workflow-sections',
  templateUrl: './workflow-sections.component.html',
  styleUrls: ['./workflow-sections.component.scss']
})
export class WorkflowSectionsComponent extends BaseComponent implements OnInit, OnChanges {

  @Input() wfTableConfig?: WFTableConfig;
  @Input() disabled?: boolean;

  showDeleted = false;

  sectionDropLists: string[] = [];
  stepDropLists: string[] = [];

  sections?: WFSectionConfig[];

  constructor(
    protected override injector: Injector,
    public service: WorkFlowService
  ) {
    super(injector);
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // this.sections = [...new Map(
    // this.wfTableConfig?.wfSectionConfigs?.map(section => [section.id, section]) // Using the section `id` as the key to ensure uniqueness
    // ).values() // Extract the unique values
    // ].sort((a, b) => (a.number ?? 0) - (b.number ?? 0));
    this.sections = this.wfTableConfig?.wfSectionConfigs?.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    this.reorder();
    this.updateDropLists();
  }

  showSection(section: WFMasterResource) {
    if (this.service.selectedNode?.sectionNode)
      this.service.selectedNode.sectionNode.id = section.id;
    else
      this.service.selectedNode = { sectionNode: { id: section.id, type: ChecklistElement.SECTION } } as SelectedElement;

    section.expanded = true;
  }

  hideSection(section: WFMasterResource) {
    if (this.service.selectedNode?.sectionNode?.id == section.id)
      this.service.selectedNode = undefined;
    section.expanded = false;
  }

  updateDropLists() {
    this.stepDropLists = [];
    this.sectionDropLists = this.sections?.map(_ => 'section-' + _.id) ?? [];
    this.sections?.map(s => {
      if (s.wfStepConfigs)
        this.stepDropLists = this.stepDropLists.concat(s.wfStepConfigs.map(_ => 'step-' + _.id));
    });
  }

  ////

  add() {
    if (!this.sections) this.sections = [];
    const maxNumber = !this.sections.length ? -1 : Math.max(...this.sections.map(s => s.number));
    const section = { name: 'New Section', number: maxNumber + 1, order: maxNumber + 1, wfTableConfigID: this.wfTableConfig?.id } as WFSectionConfig;
    this.sections.push(section);
    this.reorder();
  }

  delete(s: WFSectionConfig) {
    const index = this.sections?.indexOf(s);
    if (index !== undefined && index > -1) {
      this.sections?.splice(index, 1);
    }
    this.reorder();
  }

  duplicate(s: WFSectionConfig) {
    const section = this.utils.cloneDeep(s);
    section.id = 0;
    section.wfStepConfigs.forEach(step => {
      step.id = 0;
      step.wfTaskConfigs?.forEach(task => {
        task.id = 0;
        task.wfActionConfigs?.forEach(a => a.id = 0);
        task.wfRoleConfigs?.forEach(r => r.id = 0);
      });
      step.wfStepStatusConfigs?.forEach(status => status.id = 0);
    });

    this.sections?.push(section);
    this.reorder();
  }

  drop(e: any) {
    moveItemInArray(this.sections!,
      e.previousIndex,
      e.currentIndex);
    // updates moved data and table
    this.reorder();
    // this.setFormDirty();
  }

  reorder() {
    let order = 0
    this.sections?.forEach(s => {
      s.order = order;
      s.number = s.order + 1;
      order++;
    });
    if (this.wfTableConfig)
      this.wfTableConfig.wfSectionConfigs = this.sections;
  }

  restore(section: any) { }
  deleteForever(section: any) { }
}
